import React, { ReactNode } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";

interface IPopoverBtnProps {
  text: string;
  icon?: ReactNode;
}

export default function PopoverBtn({
  text,
  icon = <QuestionCircle />,
}: IPopoverBtnProps) {
  return (
    <>
      {text && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip className="opacity-75">{text}</Tooltip>}
        >
          <div onClick={(e) => e.stopPropagation()}>{icon}</div>
        </OverlayTrigger>
      )}
    </>
  );
}
